// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { VMessageTemplateContext } from '../../index.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VMessageTemplateContext {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VMessageTemplateContext;
}
export { assert as assertMessageTemplateContext };


export function is(value: any): value is VMessageTemplateContext {
	const result = validate(value);
    return result.success;
}
export { is as isMessageTemplateContext };


import type { ValidationResult } from '@atlassian/vindicated';
export function validate(value: any): ValidationResult<VMessageTemplateContext> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'MessageTemplateContext', value: value });
    } else {
			if (!('nextBestActionType' in value)) {
				errors.push({ path: 'value["nextBestActionType"]', expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"', value: undefined });
			} else {
				
    {
        let value__nextBestActionType___valid = false;
        
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_0 = [];
            if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({ path: 'value["nextBestActionType"]', expected: "CREATE_SPACE", value: value["nextBestActionType"] });
            if (value__nextBestActionType___errors_0.length === 0) {
                value__nextBestActionType___valid = true;
            }
        }

        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_1 = [];
            if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({ path: 'value["nextBestActionType"]', expected: "CREATE_PAGE", value: value["nextBestActionType"] });
            if (value__nextBestActionType___errors_1.length === 0) {
                value__nextBestActionType___valid = true;
            }
        }

        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_2 = [];
            if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({ path: 'value["nextBestActionType"]', expected: "CREATE_WHITEBOARD", value: value["nextBestActionType"] });
            if (value__nextBestActionType___errors_2.length === 0) {
                value__nextBestActionType___valid = true;
            }
        }

        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_3 = [];
            if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({ path: 'value["nextBestActionType"]', expected: "1_ON_1_LOOM_NUDGE", value: value["nextBestActionType"] });
            if (value__nextBestActionType___errors_3.length === 0) {
                value__nextBestActionType___valid = true;
            }
        }

        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_4 = [];
            if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({ path: 'value["nextBestActionType"]', expected: "LOOM_AI_MEETING_NOTES", value: value["nextBestActionType"] });
            if (value__nextBestActionType___errors_4.length === 0) {
                value__nextBestActionType___valid = true;
            }
        }

        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_5 = [];
            if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({ path: 'value["nextBestActionType"]', expected: "RESURRECTED_USER_NUDGE", value: value["nextBestActionType"] });
            if (value__nextBestActionType___errors_5.length === 0) {
                value__nextBestActionType___valid = true;
            }
        }

        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_6 = [];
            if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({ path: 'value["nextBestActionType"]', expected: "CREATE_WITH_ROVO_NUDGE", value: value["nextBestActionType"] });
            if (value__nextBestActionType___errors_6.length === 0) {
                value__nextBestActionType___valid = true;
            }
        }

        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_7 = [];
            if (value["nextBestActionType"] !== "MCP_SETUP_NUDGE") value__nextBestActionType___errors_7.push({ path: 'value["nextBestActionType"]', expected: "MCP_SETUP_NUDGE", value: value["nextBestActionType"] });
            if (value__nextBestActionType___errors_7.length === 0) {
                value__nextBestActionType___valid = true;
            }
        }

        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_8 = [];
            if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_8.push({ path: 'value["nextBestActionType"]', expected: "ROVO_EXTENSION_CTA", value: value["nextBestActionType"] });
            if (value__nextBestActionType___errors_8.length === 0) {
                value__nextBestActionType___valid = true;
            }
        }

        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_9 = [];
            if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_9.push({ path: 'value["nextBestActionType"]', expected: "CONNECT_3P_TOOLS_NUDGE", value: value["nextBestActionType"] });
            if (value__nextBestActionType___errors_9.length === 0) {
                value__nextBestActionType___valid = true;
            }
        }
        if (!value__nextBestActionType___valid) {
            errors.push({ path: 'value["nextBestActionType"]', expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "MCP_SETUP_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"', value: value["nextBestActionType"] });
        }
    }
			}
			if (!('cohort' in value)) {
				errors.push({ path: 'value["cohort"]', expected: '"single-connect-in-onboarding" | "multi-connect-in-onboarding" | "control"', value: undefined });
			} else {
				
    {
        let value__cohort___valid = false;
        
        if (!value__cohort___valid) {
            const value__cohort___errors_0 = [];
            if (value["cohort"] !== "single-connect-in-onboarding") value__cohort___errors_0.push({ path: 'value["cohort"]', expected: "single-connect-in-onboarding", value: value["cohort"] });
            if (value__cohort___errors_0.length === 0) {
                value__cohort___valid = true;
            }
        }

        if (!value__cohort___valid) {
            const value__cohort___errors_1 = [];
            if (value["cohort"] !== "multi-connect-in-onboarding") value__cohort___errors_1.push({ path: 'value["cohort"]', expected: "multi-connect-in-onboarding", value: value["cohort"] });
            if (value__cohort___errors_1.length === 0) {
                value__cohort___valid = true;
            }
        }

        if (!value__cohort___valid) {
            const value__cohort___errors_2 = [];
            if (value["cohort"] !== "control") value__cohort___errors_2.push({ path: 'value["cohort"]', expected: "control", value: value["cohort"] });
            if (value__cohort___errors_2.length === 0) {
                value__cohort___valid = true;
            }
        }
        if (!value__cohort___valid) {
            errors.push({ path: 'value["cohort"]', expected: '"single-connect-in-onboarding" | "multi-connect-in-onboarding" | "control"', value: value["cohort"] });
        }
    }
			}
			if (!('cloudId' in value)) {
				errors.push({ path: 'value["cloudId"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["cloudId"] !== 'string') errors.push({ path: 'value["cloudId"]', expected: 'string', value: value["cloudId"] });
			}
			if (!('userId' in value)) {
				errors.push({ path: 'value["userId"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["userId"] !== 'string') errors.push({ path: 'value["userId"]', expected: 'string', value: value["userId"] });
			}
			if (!('unconnectedApps' in value)) {
				errors.push({ path: 'value["unconnectedApps"]', expected: '("google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint")[]', value: undefined });
			} else {
				if (!Array.isArray(value["unconnectedApps"])) errors.push({ path: 'value["unconnectedApps"]', expected: 'array', value: value["unconnectedApps"] });if (Array.isArray(value["unconnectedApps"])) { value["unconnectedApps"].forEach((element, index) => { 
    {
        let element_valid = false;
        
        if (!element_valid) {
            const element_errors_0 = [];
            if (element !== "google-drive") element_errors_0.push({ path: 'element', expected: "google-drive", value: element });
            if (element_errors_0.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_1 = [];
            if (element !== "slack") element_errors_1.push({ path: 'element', expected: "slack", value: element });
            if (element_errors_1.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_2 = [];
            if (element !== "figma") element_errors_2.push({ path: 'element', expected: "figma", value: element });
            if (element_errors_2.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_3 = [];
            if (element !== "github") element_errors_3.push({ path: 'element', expected: "github", value: element });
            if (element_errors_3.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_4 = [];
            if (element !== "onedrive") element_errors_4.push({ path: 'element', expected: "onedrive", value: element });
            if (element_errors_4.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_5 = [];
            if (element !== "sharepoint") element_errors_5.push({ path: 'element', expected: "sharepoint", value: element });
            if (element_errors_5.length === 0) {
                element_valid = true;
            }
        }
        if (!element_valid) {
            errors.push({ path: 'element', expected: '"google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint"', value: element });
        }
    } }); }
			}
			if (!('topApps' in value)) {
				errors.push({ path: 'value["topApps"]', expected: '("google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint")[]', value: undefined });
			} else {
				if (!Array.isArray(value["topApps"])) errors.push({ path: 'value["topApps"]', expected: 'array', value: value["topApps"] });if (Array.isArray(value["topApps"])) { value["topApps"].forEach((element, index) => { 
    {
        let element_valid = false;
        
        if (!element_valid) {
            const element_errors_0 = [];
            if (element !== "google-drive") element_errors_0.push({ path: 'element', expected: "google-drive", value: element });
            if (element_errors_0.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_1 = [];
            if (element !== "slack") element_errors_1.push({ path: 'element', expected: "slack", value: element });
            if (element_errors_1.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_2 = [];
            if (element !== "figma") element_errors_2.push({ path: 'element', expected: "figma", value: element });
            if (element_errors_2.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_3 = [];
            if (element !== "github") element_errors_3.push({ path: 'element', expected: "github", value: element });
            if (element_errors_3.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_4 = [];
            if (element !== "onedrive") element_errors_4.push({ path: 'element', expected: "onedrive", value: element });
            if (element_errors_4.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_5 = [];
            if (element !== "sharepoint") element_errors_5.push({ path: 'element', expected: "sharepoint", value: element });
            if (element_errors_5.length === 0) {
                element_valid = true;
            }
        }
        if (!element_valid) {
            errors.push({ path: 'element', expected: '"google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint"', value: element });
        }
    } }); }
			}
			if (!('department' in value)) {
				errors.push({ path: 'value["department"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["department"] !== 'string') errors.push({ path: 'value["department"]', expected: 'string', value: value["department"] });
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateMessageTemplateContext };
